import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Instagram, UserPlus, X } from "lucide-react";
import type { InstagramPresets as InstagramPresetsData } from "@shared/schema";
import { PresetSection } from "./PresetSection";

export function InstagramPresets({
  value,
  onChange,
}: {
  value: InstagramPresetsData;
  onChange: (next: InstagramPresetsData) => void;
}) {
  const { t } = useTranslation();
  const [draft, setDraft] = useState("");

  function addCollaborator() {
    const cleaned = draft.trim().replace(/^@/, "");
    if (!cleaned || value.collaborators.includes(cleaned)) {
      setDraft("");
      return;
    }
    onChange({ ...value, collaborators: [...value.collaborators, cleaned] });
    setDraft("");
  }

  function removeCollaborator(handle: string) {
    onChange({ ...value, collaborators: value.collaborators.filter((c) => c !== handle) });
  }

  return (
    <PresetSection
      icon={<Instagram size={14} style={{ color: "#E4405F" }} />}
      title={t("contentScheduler.presets.instagram.title")}
    >
      <div>
        <span className="text-[11px] uppercase tracking-wider text-white/45 font-medium">
          {t("contentScheduler.presets.instagram.collaborators")}
        </span>
        <div className="mt-1.5 flex flex-wrap gap-1.5">
          {value.collaborators.map((handle) => (
            <span
              key={handle}
              className="inline-flex items-center gap-1 rounded-full bg-white/[0.06] border border-white/[0.1] px-2.5 py-1 text-[11px] text-white/80"
            >
              @{handle}
              <button
                type="button"
                onClick={() => removeCollaborator(handle)}
                className="text-white/40 hover:text-red-400"
              >
                <X size={10} />
              </button>
            </span>
          ))}
          <div className="inline-flex items-center gap-1 rounded-full border border-dashed border-white/20 px-2 py-1">
            <UserPlus size={11} className="text-white/40" />
            <input
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  addCollaborator();
                }
              }}
              placeholder={t("contentScheduler.presets.instagram.addCollaborator")}
              className="bg-transparent text-[11px] text-white/85 placeholder:text-white/30 focus:outline-none w-32"
            />
          </div>
        </div>
      </div>
    </PresetSection>
  );
}
